/**
 * Implements a decorator component which converts exchange name into icons and caption
 */
import { Network, helpers } from '@kattana-io/common';
import Text from '../../../../atoms/Text';
import Image from '../../../../atoms/Image';

// Cex
import binance from '../../../../assets/images/exchanges/binance.svg';
import bybit from '../../../../assets/images/exchanges/bybit.png';
import hitbtc from '../../../../assets/images/exchanges/hitbtc.png';
import kucoin from '../../../../assets/images/exchanges/kucoin.svg';
import gateio from '../../../../assets/images/exchanges/gateio.svg';
import huobi from '../../../../assets/images/exchanges/huobi.svg';
import okx from '../../../../assets/images/exchanges/okex.png';
// Dex
import uniswap from '../../../../assets/images/exchanges/uniswap.svg';
import pancakeswap from '../../../../assets/images/exchanges/pancakeswap.svg';
import sushiswap from '../../../../assets/images/exchanges/sushiswap.svg';
import traderjoe from '../../../../assets/images/exchanges/traderjoe.png';
import shibaswap from '../../../../assets/images/exchanges/shibaswap.png';
import pangolin from '../../../../assets/images/exchanges/pangolin.svg';
import quickswap from '../../../../assets/images/exchanges/quickswap.svg';
import mdex from '../../../../assets/images/exchanges/mdex.svg';
import impossibleswap from '../../../../assets/images/exchanges/impossibleswap.svg';
import maiar from '../../../../assets/images/exchanges/maiar.svg';
import spookyswap from '../../../../assets/images/exchanges/spookyswap.svg';
import biswap from '../../../../assets/images/exchanges/biswap.svg';
import sunswap from '../../../../assets/images/exchanges/sunswap.png';
import justmoney from '../../../../assets/images/exchanges/justmoney.svg';
import kyber from '../../../../assets/images/exchanges/kyber.svg';
import okxdex from '../../../../assets/images/exchanges/okxdex.png';
import cherryswap from '../../../../assets/images/exchanges/cherryswap.svg';
import jswap from '../../../../assets/images/exchanges/okc_jswap.png';
import kswap from '../../../../assets/images/exchanges/okc_kswap.png';
import velodrome from '../../../../assets/images/exchanges/velodrome.png';
import thena from '../../../../assets/images/exchanges/thena.png';
import syncswap from '../../../../assets/images/exchanges/syncswap.svg';
import padswap from '../../../../assets/images/exchanges/padswap.png';
import arbidex from '../../../../assets/images/exchanges/arbidex.png';
import velocimeter from '../../../../assets/images/exchanges/velocimeter.png';
import canto from '../../../../assets/images/chains/canto.svg';

interface IExchangeIconProps {
  exchange: string;
  chain?: string;
  textProps?: any;
  imageProps?: any;
}

const ExchangeIcon = ({
  exchange,
  chain = '',
  textProps = {},
  imageProps = {},
}: IExchangeIconProps) => {
  switch (exchange) {
  case helpers.exchanges.BINANCE:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Binance
        </Text>
        <Image size='s' src={binance} {...imageProps} />
      </span>
    );
  case helpers.exchanges.GATEIO:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Gate.io
        </Text>
        <Image
          size='s'
          src={gateio}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.HITBTC:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          HitBTC
        </Text>
        <Image
          size='s'
          src={hitbtc}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.HUOBI:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Huobi
        </Text>
        <Image
          size='s'
          src={huobi}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.KUCOIN:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Kucoin
        </Text>
        <Image size='s' src={kucoin} className='okex_icon' {...imageProps} />
      </span>
    );
  case helpers.exchanges.OKX:
    return (
      <span style={{ display: 'flex' }}>
        <Image size='s' src={okx} className='okex_icon' {...imageProps} />
      </span>
    );
  case helpers.exchanges.BYBIT:
    return (
      <span style={{ display: 'flex' }}>
        <Image size='s' src={bybit} className='okex_icon' {...imageProps} />
      </span>
    );
  case helpers.exchanges.UNISWAP:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Uni
        </Text>
        <Image size='s' src={uniswap} {...imageProps} />
      </span>
    );
  case helpers.exchanges.SUSHISWAP:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Sushi
        </Text>
        <Image size='s' src={sushiswap} {...imageProps} />
      </span>
    );
  case helpers.exchanges.QUICKSWAP:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Quickswap
        </Text>
        <Image
          size='s'
          src={quickswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.MDEX:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Mdex
        </Text>
        <Image
          size='s'
          src={mdex}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.PANCAKE:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Pancake
        </Text>
        <Image
          size='s'
          src={pancakeswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.IMPOSSIBLE:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Impossible
        </Text>
        <Image
          size='s'
          src={impossibleswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.MAIAR:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          xExchange
        </Text>
        <Image
          size='s'
          src={maiar}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.TRADERJOE:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Traderjoe
        </Text>
        <Image
          size='s'
          src={traderjoe}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.PANGOLIN:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Pangolin
        </Text>
        <Image
          size='s'
          src={pangolin}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.SPOOKYSWAP:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Spookyswap
        </Text>
        <Image
          size='s'
          src={spookyswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.JUSTMONEY:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Justmoney
        </Text>
        <Image
          size='s'
          src={justmoney}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.SUNSWAP:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Sunswap
        </Text>
        <Image
          size='s'
          src={sunswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.KYBER:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          KyberDMM
        </Text>
        <Image
          size='s'
          src={kyber}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.BISWAP:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Biswap
        </Text>
        <Image
          size='s'
          src={biswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case 'shibaswap':
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Shibaswap
        </Text>
        <Image
          size='s'
          src={shibaswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.OKXDEX:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          OKC DEX
        </Text>
        <Image
          size='s'
          src={okxdex}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.CHERRYSWAP:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Cherryswap
        </Text>
        <Image
          size='s'
          src={cherryswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case 'jswap':
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          JSwap
        </Text>
        <Image
          size='s'
          src={jswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case 'kswap':
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          KSwap
        </Text>
        <Image
          size='s'
          src={kswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.VELODROME:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Velodrome
        </Text>
        <Image
          size='s'
          src={velodrome}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.THENA:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Thena
        </Text>
        <Image
          size='s'
          src={thena}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.PADSWAP:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Padswap
        </Text>
        <Image
          size='s'
          src={padswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.SYNCSWAP:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Syncswap
        </Text>
        <Image
          size='s'
          src={syncswap}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.NATIVECANTO:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Canto
        </Text>
        <Image
          size='s'
          src={canto}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.ARBIDEX:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Arbidex
        </Text>
        <Image
          size='s'
          src={arbidex}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case helpers.exchanges.VELOCIMETER:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          Velocimeter
        </Text>
        <Image
          size='s'
          src={velocimeter}
          className='exchange_icon'
          {...imageProps}
        />
      </span>
    );
  case 'ORPHAN':
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          {Network.isValidChain(chain)
            ? Network.fromChain(chain).getTitle()
            : chain}
          -dex
        </Text>
      </span>
    );
  default:
    return (
      <span style={{ display: 'flex' }}>
        <Text className='text--grey-600' size={12} {...textProps}>
          {exchange}
        </Text>
      </span>
    );
  }
};

export default ExchangeIcon;
